import axios, { AxiosResponse } from 'axios';
import { AppThunk } from '../../app/store';
import { GetLiveConnections } from '../../types/API';
import { setError } from '../../features/uiSlice';
import { setFileToLiveCount } from '../../features/fileToLivesSlice';
import { NOT_FOUND } from '../Const';
import {
  FILE_TO_LIVE_CONNECTION_GRAPH_ERR_MSG,
  GET_FILE_TO_LIVE_COUNT_API_ERR_MSG,
  NOT_PARAMETER_ERR_MSG,
} from '../Message';

type getCountType = {
  cid: number;
  flpid: number;
  timeInterval?: number;
  from?: number;
  to?: number;
};
/** ライブ同時接続取得 */
export const getCount =
  (arg: getCountType): AppThunk =>
  async (dispatch) => {
    try {
      // パラメータに不足がある場合はエラー
      if (!arg.from || !arg.to) {
        const noparam: string[] = [];
        if (!arg.from) {
          noparam.push('ライブ開始時刻');
        }
        if (!arg.to) {
          noparam.push('ライブ停止時刻');
        }
        dispatch(
          setError({
            msg: FILE_TO_LIVE_CONNECTION_GRAPH_ERR_MSG,
            detail: `${NOT_PARAMETER_ERR_MSG}: ${noparam.join()}`,
          })
        );
        return;
      }
      // ライブ同時接続取得API実行
      const response: AxiosResponse<GetLiveConnections> = await axios.get(
        `${String(process.env.REACT_APP_BACKEND_API_ENDPOINT)}getCount`,
        {
          params: {
            cid: arg.cid,
            lpid: arg.flpid,
            leid: 999999,
            timeInterval: arg.timeInterval || 30,
            from: arg.from,
            to: arg.to,
          },
          headers: {
            accept: 'application/json',
            'Content-type': 'application/json',
          },
        }
      );
      if (!response.data.data || response.data.data.length <= 0) {
        // 異常終了
        throw new Error(GET_FILE_TO_LIVE_COUNT_API_ERR_MSG);
      }

      // 正常終了
      dispatch(setFileToLiveCount(response.data));

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (error.response?.data?.statusCode === NOT_FOUND) return;
      // 異常終了
      dispatch(
        setError({
          msg: GET_FILE_TO_LIVE_COUNT_API_ERR_MSG,
          detail: JSON.stringify(error.response?.data || error.message),
        })
      );
    }
  };

export default getCount;
